import { node, arrayOf, oneOfType } from 'prop-types';
import { components } from 'react-select';

const Control = ({ children, ...rest }) => (
  <div data-testid='control'>
    <components.Control {...rest}>{children}</components.Control>
  </div>
);

Control.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired
};

export default Control;
